// extracted by css-extract-rspack-plugin
export default {"fade":"_fade_M8C6v","spin":"_spin_cEHtN","fadeIn":"_fadeIn_rK3lE","pathLoading":"_pathLoading_YEaCz","pathEnter":"_pathEnter_YtDm6","bounce":"_bounce_ffG8N"};